"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileField = exports.ProfilePageItem = exports.ProfileSectionHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useWindowUtils_1 = require("../../hooks/useWindowUtils/useWindowUtils");
const Styled = __importStar(require("./ProfileComponents.styles"));
const ProfileSectionHeader = ({ title, actionButton }) => {
    const { isMobileView } = (0, useWindowUtils_1.useWindowUtils)();
    return ((0, jsx_runtime_1.jsxs)(Styled.SectionHeader, { children: [(0, jsx_runtime_1.jsx)(Styled.SectionTitle, { variant: isMobileView ? 'h5' : 'h4', children: title }), actionButton] }));
};
exports.ProfileSectionHeader = ProfileSectionHeader;
const ProfilePageItem = ({ children }) => ((0, jsx_runtime_1.jsx)(Styled.PageItem, { children: children }));
exports.ProfilePageItem = ProfilePageItem;
const ProfileField = ({ label, children }) => ((0, jsx_runtime_1.jsxs)(Styled.Field, { children: [(0, jsx_runtime_1.jsx)(Styled.FieldLabel, { children: label }), (0, jsx_runtime_1.jsx)(Styled.FieldValue, { children: children })] }));
exports.ProfileField = ProfileField;
